export default __webpack_public_path__ + "e35239fd8b691e61d87c29fdb514fcb8.png";